module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/plus-0c46dd1755eb1bf620bc87d3bf6ec1d3.svg";